//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ActivityActions from "./actions";
import { logToSentry } from "utils/networkErrorUtils";
// import { has } from "lodash";
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List resources ----------------

export const handleCreateRubric = (payload) => async (dispatch) => {
  try {
    const data = await apis.post("rubric", `/create`, {
      body: payload,
    });
    await dispatch(ActivityActions.createRubric(data));

    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'creating rubric',
                error,
                module: 'RUBRIC',
                operation: 'CREATE_RUBRIC'
            });
    }
    await dispatch(ActivityActions.rubricFail(error));
  }
};

export const handleEditRubric = (payload) => async (dispatch) => {
  try {
    const data = await apis.post("rubric", `/create`, {
      body: payload,
    });
    await dispatch(
      ActivityActions.rubricEdit({ id: payload.id, data: payload })
    );

    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'editing rubric',
                error,
                module: 'RUBRIC',
                operation: 'EXPORT_RESOURCE'
            });
    }
    await dispatch(ActivityActions.rubricFail(error));
  }
};

export const handleGetRubric = (userId) => async (dispatch) => {
  try {
    const data = await apis.get("rubric", `/list/${userId}`);
    await dispatch(ActivityActions.rubricInit(data));
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'getting rubric',
                error,
                module: 'RUBRIC',
                operation: 'GET_RUBRIC'
            });
    }
    await dispatch(ActivityActions.rubricFail(error));
  }
};

export const handleDeleteRubric = (rubricId) => async (dispatch) => {
  try {
    const data = await apis.del("rubric", `/delete/${rubricId}`);
    await dispatch(ActivityActions.rubricDelete(rubricId));

    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'deleting rubric',
                error,
                module: 'RUBRIC',
                operation: 'DELETE_RUBRIC'
            });
    }
    await dispatch(ActivityActions.rubricFail(error));
  }
};
